import React from "react";
import SvgIcon from "../SvgIcon/SvgIcon";
import { UiVisibilitySetting } from "../../data/ui/uiVisibilitySettingsMock";
import UiVisibilityCard from "./UiVisibilityCard";

/**
 * 🧱 Props del grid
 */
interface UiVisibilityGridProps {
  items: UiVisibilitySetting[];
  onToggle: (id: number) => void;
}

/**
 * 🧩 Mapa local entre código UI y nombre de ícono global (reales)
 */
const uiIconMap: Record<string, string> = {
  SEARCH_BAR: "search",
  DARK_MODE_SWITCH: "moon",
  NOTIFICATIONS: "notification",
  MESSAGES: "message",
  PROFILE: "user",
  CONTACTS: "contacts",
  ACCOUNT: "settings",
};

/**
 * 🧱 Contenedor en grid de todas las configuraciones UI
 */
const UiVisibilityGrid: React.FC<UiVisibilityGridProps> = ({ items, onToggle }) => {
  return (
    <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {items.map((item) => (
        <UiVisibilityCard
          key={item.id}
          code={item.code}
          label={item.code.replaceAll("_", " ")} // ej: "SEARCH BAR"
          icon={
            <SvgIcon
              name={(uiIconMap[item.code] || "default") as any}
              width={28}
              height={28}
              className="text-primary"
            />
          }
          visible={item.visible}
          onToggle={() => onToggle(item.id)}
        />
      ))}
    </div>
  );
};

export default UiVisibilityGrid;
